export default {
    frameLabel: '图框',
    frameIcon: `<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em">
            <rect x="2" y="2" width="20" height="20" rx="4"/>
            <rect x="6" y="6" width="12" height="12" rx="1"/>
        </g>`,

    frameLabelMatSharp: '无光泽',
    frameLabelMatRound: '凹凸效果',
    frameLabelLineSingle: '线条',
    frameLabelLineMultiple: '斑纹',
    frameLabelEdgeSeparate: '套印',
    frameLabelEdgeOverlap: '+字形',
    frameLabelEdgeCross: '木材',
    frameLabelCornerHooks: '挂钩',
    frameLabelPolaroid: '宝丽莱',
};
